import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'
import React from 'react'

const Container = styled(Box)`
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
`
CircularProgress.Centered = (props) => (
  <Container>
    <CircularProgress {...props} />
  </Container>
)

export default CircularProgress
